var _defs, _g, _g2, _g3, _path, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _path2, _path3, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 425.388,
    height: 485.198,
    viewBox: "0 0 425.388 485.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63086",
    "data-name": "Path 63086",
    d: "M557.007,500.078c5.49-4.5,12.977-7,18.2-8.293v-.007c.273-.066.557-.129.833-.194l.169-.039c5.69-1.333,12.182-2.417,19.09-3.373a220.818,220.818,0,0,1,50.1,1.393l.006.014a46.265,46.265,0,0,1,15.66,4.877,92.286,92.286,0,0,0,29.827,10.726s-6.69.515-7.719,15.094-1.8,21.4-6.108,25.916l-19.107-7.219-.074-.123c-.032,16.929.407,42.758,2.861,64.129,0,0-21.149,2.937-51.11.881S566.4,591.131,559.82,601c0,0,7.715-33.2,10.2-52.864.31-2.446.611-5,.9-7.608l-17.879,14.708c-3.349-1.116-5.6-4.734-10.8-12.92A30.589,30.589,0,0,0,528.516,531S546.58,508.625,557.007,500.078Z",
    transform: "translate(-528.516 -487.352)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15380",
    "data-name": "Group 15380",
    transform: "translate(-199.095 -221.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15091",
    "data-name": "Group 15091",
    transform: "translate(209.286 221.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15052",
    "data-name": "Group 15052",
    transform: "translate(0 0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15033",
    "data-name": "Group 15033",
    transform: "translate(0 100.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15032",
    "data-name": "Group 15032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15029",
    "data-name": "Group 15029",
    transform: "translate(0 2.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15028",
    "data-name": "Group 15028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62984",
    "data-name": "Path 62984",
    d: "M224.472,497.614a.286.286,0,0,0,.261-.169c4.076-9.059,13.74-17.447,24.62-21.371a.286.286,0,1,0-.194-.537c-11.018,3.974-20.811,12.481-24.947,21.674a.286.286,0,0,0,.26.4Z",
    transform: "translate(-224.187 -475.52)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15031",
    "data-name": "Group 15031",
    transform: "translate(0.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15030",
    "data-name": "Group 15030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62985",
    "data-name": "Path 62985",
    d: "M224.644,480.9a.286.286,0,0,0,.245-.138c2.87-4.745,7.118-8.115,12.985-10.3a.286.286,0,1,0-.2-.535c-5.993,2.236-10.335,5.685-13.274,10.543a.286.286,0,0,0,.244.434Z",
    transform: "translate(-224.358 -469.903)",
    fill: "#502a59"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15051",
    "data-name": "Group 15051",
    transform: "translate(251.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15050",
    "data-name": "Group 15050"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15036",
    "data-name": "Group 15036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15035",
    "data-name": "Group 15035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15034",
    "data-name": "Group 15034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62986",
    "data-name": "Path 62986",
    d: "M842.643,228.927V346.251a6.975,6.975,0,0,0,6.974,6.977H999.685a6.975,6.975,0,0,0,6.974-6.977V228.927a6.974,6.974,0,0,0-6.974-6.974H849.617a6.468,6.468,0,0,0-.915.063.083.083,0,0,0-.039.007,5.53,5.53,0,0,0-.66.121A6.976,6.976,0,0,0,842.643,228.927Z",
    transform: "translate(-842.643 -221.953)",
    fill: "#f6ab36"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15047",
    "data-name": "Group 15047",
    transform: "translate(19.894 17.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15038",
    "data-name": "Group 15038",
    transform: "translate(0 72.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15037",
    "data-name": "Group 15037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62987",
    "data-name": "Path 62987",
    d: "M1006.768,461.676H900.712a9.086,9.086,0,0,1-9.086-9.086h0a9.086,9.086,0,0,1,9.086-9.086h106.056a9.086,9.086,0,0,1,9.086,9.086h0A9.086,9.086,0,0,1,1006.768,461.676Z",
    transform: "translate(-891.626 -443.504)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15046",
    "data-name": "Group 15046",
    transform: "translate(32.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15040",
    "data-name": "Group 15040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15039",
    "data-name": "Group 15039"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_636",
    "data-name": "Ellipse 636",
    cx: 29.677,
    cy: 29.677,
    r: 29.677,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15045",
    "data-name": "Group 15045",
    transform: "translate(25.274 10.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15042",
    "data-name": "Group 15042",
    transform: "translate(1.083 32.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15041",
    "data-name": "Group 15041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62988",
    "data-name": "Path 62988",
    d: "M1036.385,374.632a3.321,3.321,0,1,0,3.321-3.321A3.321,3.321,0,0,0,1036.385,374.632Z",
    transform: "translate(-1036.385 -371.311)",
    fill: "#7a54cc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15044",
    "data-name": "Group 15044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15043",
    "data-name": "Group 15043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62989",
    "data-name": "Path 62989",
    d: "M1035.65,319.076h4.947l1.93-28.862h-8.807Z",
    transform: "translate(-1033.719 -290.215)",
    fill: "#7a54cc"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15049",
    "data-name": "Group 15049",
    transform: "translate(0 0.059)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15048",
    "data-name": "Group 15048",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_62990",
    "data-name": "Path 62990",
    d: "M842.643,229.013V340.934l0,.23a12.143,12.143,0,0,0,12.147,12.147h98.774C923.919,333,872.176,289.341,848.7,222.1v0l-.039.01c-.2.046-.427.085-.66.121A6.976,6.976,0,0,0,842.643,229.013Z",
    transform: "translate(-842.643 -222.098)",
    fill: "#47068c"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15090",
    "data-name": "Group 15090",
    transform: "translate(35.414 6.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15062",
    "data-name": "Group 15062",
    transform: "translate(238.26 272.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15057",
    "data-name": "Group 15057",
    transform: "translate(36.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15054",
    "data-name": "Group 15054",
    transform: "translate(6.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15053",
    "data-name": "Group 15053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62991",
    "data-name": "Path 62991",
    d: "M1002.783,921.421a.571.571,0,0,0,.572-.571V908.365a.572.572,0,0,0-1.143,0V920.85A.571.571,0,0,0,1002.783,921.421Z",
    transform: "translate(-1002.212 -907.794)",
    fill: "#ebb821"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15056",
    "data-name": "Group 15056",
    transform: "translate(0 6.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15055",
    "data-name": "Group 15055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62992",
    "data-name": "Path 62992",
    d: "M987.414,924.307H999.9a.571.571,0,1,0,0-1.143H987.414a.571.571,0,0,0,0,1.143Z",
    transform: "translate(-986.843 -923.164)",
    fill: "#ebb821"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15059",
    "data-name": "Group 15059",
    transform: "translate(0 45.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15058",
    "data-name": "Group 15058"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_637",
    "data-name": "Ellipse 637",
    cx: 3.758,
    cy: 3.758,
    r: 3.758,
    fill: "#9c78e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15061",
    "data-name": "Group 15061",
    transform: "translate(25.315 81.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15060",
    "data-name": "Group 15060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62993",
    "data-name": "Path 62993",
    d: "M960.355,1114.264a5.3,5.3,0,1,1,5.3,5.3A5.31,5.31,0,0,1,960.355,1114.264Zm1.143,0a4.161,4.161,0,1,0,4.161-4.16A4.165,4.165,0,0,0,961.5,1114.264Z",
    transform: "translate(-960.355 -1108.961)",
    fill: "#56ba85"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15074",
    "data-name": "Group 15074",
    transform: "translate(0 287.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15064",
    "data-name": "Group 15064",
    transform: "translate(15.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15063",
    "data-name": "Group 15063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62994",
    "data-name": "Path 62994",
    d: "M350.213,954.813a9.746,9.746,0,1,1,9.746,9.746A9.757,9.757,0,0,1,350.213,954.813Zm1.143,0a8.6,8.6,0,1,0,8.6-8.6A8.613,8.613,0,0,0,351.356,954.813Z",
    transform: "translate(-350.213 -945.067)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15066",
    "data-name": "Group 15066",
    transform: "translate(0 66.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15065",
    "data-name": "Group 15065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62995",
    "data-name": "Path 62995",
    d: "M311.382,1114.343a6.156,6.156,0,1,1,6.155,6.156A6.163,6.163,0,0,1,311.382,1114.343Zm1.143,0a5.013,5.013,0,1,0,5.013-5.013A5.019,5.019,0,0,0,312.525,1114.343Z",
    transform: "translate(-311.382 -1108.187)",
    fill: "#9c78e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15068",
    "data-name": "Group 15068",
    transform: "translate(37.484 85.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15067",
    "data-name": "Group 15067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62996",
    "data-name": "Path 62996",
    d: "M403.675,1160.221a3.563,3.563,0,1,1,3.563,3.563A3.567,3.567,0,0,1,403.675,1160.221Zm1.143,0a2.42,2.42,0,1,0,2.42-2.42A2.423,2.423,0,0,0,404.818,1160.221Z",
    transform: "translate(-403.675 -1156.658)",
    fill: "#9c78e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15073",
    "data-name": "Group 15073",
    transform: "translate(13.031 124.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15070",
    "data-name": "Group 15070",
    transform: "translate(4.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15069",
    "data-name": "Group 15069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62997",
    "data-name": "Path 62997",
    d: "M355.787,1262.845a.571.571,0,0,0,.571-.571v-9.544a.571.571,0,1,0-1.143,0v9.544A.571.571,0,0,0,355.787,1262.845Z",
    transform: "translate(-355.216 -1252.158)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15072",
    "data-name": "Group 15072",
    transform: "translate(0 4.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15071",
    "data-name": "Group 15071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62998",
    "data-name": "Path 62998",
    d: "M344.038,1265.051h9.544a.571.571,0,0,0,0-1.143h-9.544a.571.571,0,0,0,0,1.143Z",
    transform: "translate(-343.467 -1263.908)",
    fill: "#502a59"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15089",
    "data-name": "Group 15089",
    transform: "translate(29.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15076",
    "data-name": "Group 15076",
    transform: "translate(0 43.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15075",
    "data-name": "Group 15075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62999",
    "data-name": "Path 62999",
    d: "M384.15,347.995a4.76,4.76,0,1,1,4.76,4.76A4.766,4.766,0,0,1,384.15,347.995Zm1.143,0a3.617,3.617,0,1,0,3.617-3.617A3.621,3.621,0,0,0,385.293,347.995Z",
    transform: "translate(-384.15 -343.235)",
    fill: "#56ba85"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15078",
    "data-name": "Group 15078",
    transform: "translate(33.346 52.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15077",
    "data-name": "Group 15077",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_638",
    "data-name": "Ellipse 638",
    cx: 7.29,
    cy: 7.29,
    r: 7.29,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 0, 3.35)",
    fill: "#9c78e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15083",
    "data-name": "Group 15083",
    transform: "translate(41.781 15.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15080",
    "data-name": "Group 15080",
    transform: "translate(4.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15079",
    "data-name": "Group 15079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63000",
    "data-name": "Path 63000",
    d: "M499.343,285.38a.571.571,0,0,0,.571-.571v-9.544a.571.571,0,0,0-1.143,0v9.544A.571.571,0,0,0,499.343,285.38Z",
    transform: "translate(-498.772 -274.694)",
    fill: "#56ba85"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15082",
    "data-name": "Group 15082",
    transform: "translate(0 4.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15081",
    "data-name": "Group 15081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63001",
    "data-name": "Path 63001",
    d: "M487.594,287.586h9.544a.571.571,0,1,0,0-1.143h-9.544a.571.571,0,0,0,0,1.143Z",
    transform: "translate(-487.023 -286.443)",
    fill: "#56ba85"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15088",
    "data-name": "Group 15088",
    transform: "translate(96.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15085",
    "data-name": "Group 15085",
    transform: "translate(3.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15084",
    "data-name": "Group 15084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63002",
    "data-name": "Path 63002",
    d: "M631.581,244.866a.571.571,0,0,0,.571-.571v-6.773a.571.571,0,1,0-1.143,0v6.773A.571.571,0,0,0,631.581,244.866Z",
    transform: "translate(-631.01 -236.95)",
    fill: "#9c78e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15087",
    "data-name": "Group 15087",
    transform: "translate(0 3.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15086",
    "data-name": "Group 15086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63003",
    "data-name": "Path 63003",
    d: "M623.241,246.432h6.774a.571.571,0,1,0,0-1.143h-6.774a.571.571,0,1,0,0,1.143Z",
    transform: "translate(-622.67 -245.289)",
    fill: "#9c78e8"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15379",
    "data-name": "Group 15379",
    transform: "translate(199.095 255.442)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15093",
    "data-name": "Group 15093",
    transform: "translate(303.974 124.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15092",
    "data-name": "Group 15092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63004",
    "data-name": "Path 63004",
    d: "M947.812,650.458a.285.285,0,0,1-.275-.3.3.3,0,0,1,.3-.275c13.47.488,23.957-1.55,31.356-13.1a31.479,31.479,0,0,0,2.922-5.759c-2.974-2.832-4.716-7.255-5.18-11.484-.458-4.17.423-7.235,2.192-7.629,1.182-.263,2.361.347,3.319,1.717,2.091,2.993,3.091,9.7.336,17.233a9.844,9.844,0,0,0,6.7,2.605c12.159,0,17.571-11.96,17.625-12.08a.286.286,0,0,1,.523.23c-.055.125-5.61,12.422-18.148,12.422a10.366,10.366,0,0,1-6.913-2.6,31.977,31.977,0,0,1-2.892,5.658c-6.9,10.764-16.382,13.429-28.4,13.429Q949.577,650.524,947.812,650.458Zm31.434-37.984c-1.423.316-2.159,3.264-1.747,7.008a18.586,18.586,0,0,0,4.829,10.959c2.587-7.238,1.64-13.626-.355-16.482a3,3,0,0,0-2.32-1.531A1.843,1.843,0,0,0,979.246,612.474Z",
    transform: "translate(-947.536 -611.856)",
    fill: "#502a59"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15378",
    "data-name": "Group 15378"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15098",
    "data-name": "Group 15098",
    transform: "translate(129.312 436.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15095",
    "data-name": "Group 15095",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15094",
    "data-name": "Group 15094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63005",
    "data-name": "Path 63005",
    d: "M517.771,1378.927H680.666a.286.286,0,0,0,0-.572H517.771a.286.286,0,1,0,0,.572Z",
    transform: "translate(-517.485 -1378.356)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15097",
    "data-name": "Group 15097",
    transform: "translate(184.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15096",
    "data-name": "Group 15096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63006",
    "data-name": "Path 63006",
    d: "M972.373,1378.927H1000.8a.286.286,0,1,0,0-.572H972.373a.286.286,0,1,0,0,.572Z",
    transform: "translate(-972.087 -1378.356)",
    fill: "#502a59"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15377",
    "data-name": "Group 15377"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15130",
    "data-name": "Group 15130",
    transform: "translate(239.753 19.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15119",
    "data-name": "Group 15119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15100",
    "data-name": "Group 15100",
    transform: "translate(18.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15099",
    "data-name": "Group 15099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63007",
    "data-name": "Path 63007",
    d: "M840.7,363.629l-6.365,12.27,16.574,9.218,7.329-7.337a29.474,29.474,0,0,0-4.264-9.319c-3.5-5.4-8.392-8.726-11.106-11.234s-7.267-6.432-8.281-5.377C833.432,353.05,840.7,363.629,840.7,363.629Z",
    transform: "translate(-834.334 -351.675)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15102",
    "data-name": "Group 15102",
    transform: "translate(0 7.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15101",
    "data-name": "Group 15101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63008",
    "data-name": "Path 63008",
    d: "M807.657,387.213s-8.262-5.639-9.809-6.812c-2.083-1.58-9.074-7.3-8.389-9.014.844-2.114,8.444,1.413,11.122,2.6s11.57,6.19,11.57,6.19Z",
    transform: "translate(-789.412 -370.726)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15104",
    "data-name": "Group 15104",
    transform: "translate(4.025 5.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15103",
    "data-name": "Group 15103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63009",
    "data-name": "Path 63009",
    d: "M817.288,381.759s-8.109-6.186-9.586-7.447-9.022-6.72-8.337-8.437c.844-2.114,8.366.725,10.973,2.374,2.475,1.566,11.444,6.472,11.444,6.472Z",
    transform: "translate(-799.322 -365.122)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15106",
    "data-name": "Group 15106",
    transform: "translate(8.197 3.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15105",
    "data-name": "Group 15105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63010",
    "data-name": "Path 63010",
    d: "M827.91,375.566s-8.109-6.186-9.586-7.447-9.373-6.374-8.687-8.091c.844-2.114,8.519,1.125,11.2,2.31s11.57,6.19,11.57,6.19Z",
    transform: "translate(-809.595 -359.328)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15108",
    "data-name": "Group 15108",
    transform: "translate(7.14 21.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15107",
    "data-name": "Group 15107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63011",
    "data-name": "Path 63011",
    d: "M827.9,420.05s-7.158-.1-10.422-2.368-11.142-8.635-10.446-10.85,7.412-.638,11.061,1.179a10.29,10.29,0,0,1,9.752.581,16.139,16.139,0,0,1,6.822,8.637Z",
    transform: "translate(-806.992 -405.748)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15110",
    "data-name": "Group 15110",
    transform: "translate(17.959 22.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15109",
    "data-name": "Group 15109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63012",
    "data-name": "Path 63012",
    d: "M844.333,411.5a.286.286,0,0,0,.211-.478c-2.9-3.176-6.416-3.8-10.743-1.905a.286.286,0,1,0,.23.523c4.074-1.784,7.374-1.205,10.091,1.768A.286.286,0,0,0,844.333,411.5Z",
    transform: "translate(-833.631 -408.05)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15112",
    "data-name": "Group 15112",
    transform: "translate(4.046 8.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15111",
    "data-name": "Group 15111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63013",
    "data-name": "Path 63013",
    d: "M813.292,380.661a.286.286,0,0,0,.166-.519c-4.179-2.977-9.035-5.9-13.651-8.644a.286.286,0,0,0-.292.491c4.606,2.735,9.45,5.654,13.612,8.618A.284.284,0,0,0,813.292,380.661Z",
    transform: "translate(-799.375 -371.458)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15114",
    "data-name": "Group 15114",
    transform: "translate(9.163 5.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15113",
    "data-name": "Group 15113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63014",
    "data-name": "Path 63014",
    d: "M825.652,374.885a.286.286,0,0,0,.17-.516,121.2,121.2,0,0,0-13.428-8.507.286.286,0,1,0-.267.505,120.538,120.538,0,0,1,13.356,8.462A.283.283,0,0,0,825.652,374.885Z",
    transform: "translate(-811.974 -365.829)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15116",
    "data-name": "Group 15116",
    transform: "translate(16.195 4.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15115",
    "data-name": "Group 15115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63015",
    "data-name": "Path 63015",
    d: "M840.151,369.821a.286.286,0,0,0,.188-.5,41.2,41.2,0,0,0-10.651-6.709.286.286,0,0,0-.229.524,40.618,40.618,0,0,1,10.5,6.615A.284.284,0,0,0,840.151,369.821Z",
    transform: "translate(-829.288 -362.588)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15118",
    "data-name": "Group 15118",
    transform: "translate(23.745 11.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15117",
    "data-name": "Group 15117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63016",
    "data-name": "Path 63016",
    d: "M848.162,392.237a.286.286,0,0,0,.285-.271,16.911,16.911,0,0,1,5.191-11.173.286.286,0,0,0-.407-.4,17.468,17.468,0,0,0-5.355,11.545.286.286,0,0,0,.271.3Z",
    transform: "translate(-847.876 -380.306)",
    fill: "#502a59"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15129",
    "data-name": "Group 15129",
    transform: "translate(28.052 26.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15121",
    "data-name": "Group 15121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15120",
    "data-name": "Group 15120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63017",
    "data-name": "Path 63017",
    d: "M876.813,461.776l11.783,1.205-30.115-36.87,14.1-10.157s36.661,31.137,46.1,49.77c3.773,7.446,5.1,25.34-17.077,28.92-7.153,1.156-28.289-3.427-28.289-3.427Z",
    transform: "translate(-858.481 -415.954)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15123",
    "data-name": "Group 15123",
    transform: "translate(19.267 46.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15122",
    "data-name": "Group 15122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63018",
    "data-name": "Path 63018",
    d: "M905.92,560.606c.04.006.086.017.131.028,4.349.834,11.023,2,16.526,2.474-10.995-15.8-3.966-29.3-3.966-29.3l-1.846-2.332-1.823-.188h-.011c-.777.12-6.674,1.469-7.634,15.081C906.88,552.263,906.508,556.891,905.92,560.606Z",
    transform: "translate(-905.92 -531.285)",
    fill: "#cc5768"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15128",
    "data-name": "Group 15128",
    transform: "translate(25.233 40.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15125",
    "data-name": "Group 15125",
    transform: "translate(32.494 15.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15124",
    "data-name": "Group 15124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63019",
    "data-name": "Path 63019",
    d: "M1000.9,564.235a.285.285,0,0,0,.242-.134c2.043-3.268,1.475-8.034,1.45-8.235a.286.286,0,1,0-.567.071c.006.047.566,4.768-1.367,7.862a.286.286,0,0,0,.242.437Z",
    transform: "translate(-1000.615 -555.615)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15127",
    "data-name": "Group 15127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15126",
    "data-name": "Group 15126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63020",
    "data-name": "Path 63020",
    d: "M929.138,527.379a.286.286,0,0,0,.223-.465l-8.243-10.247a.286.286,0,1,0-.445.358l8.243,10.247A.285.285,0,0,0,929.138,527.379Z",
    transform: "translate(-920.609 -516.561)",
    fill: "#502a59"
  }))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15200",
    "data-name": "Group 15200",
    transform: "translate(0 94.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15139",
    "data-name": "Group 15139",
    transform: "translate(71.511 13.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15132",
    "data-name": "Group 15132",
    transform: "translate(40.674 9.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15131",
    "data-name": "Group 15131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63021",
    "data-name": "Path 63021",
    d: "M518.216,611.309s-22.957,21.17-28.006,22.723-14.894-5.973-14.894-5.973l10.279-22.769,12.233-12.428C509.069,593.684,515.307,600.5,518.216,611.309Z",
    transform: "translate(-475.316 -592.862)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15134",
    "data-name": "Group 15134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15133",
    "data-name": "Group 15133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63022",
    "data-name": "Path 63022",
    d: "M428.224,592.884,387.395,569.59l-12.227,11.692s11.674,11.691,23.371,21c7.637,6.074,19.317,13.38,19.317,13.38Z",
    transform: "translate(-375.168 -569.59)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15136",
    "data-name": "Group 15136",
    transform: "translate(45.238 18.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15135",
    "data-name": "Group 15135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63023",
    "data-name": "Path 63023",
    d: "M497.767,622.187a.286.286,0,0,0,.146-.531l-10.929-6.5a.286.286,0,0,0-.292.491l10.929,6.5A.284.284,0,0,0,497.767,622.187Z",
    transform: "translate(-486.552 -615.113)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15138",
    "data-name": "Group 15138",
    transform: "translate(9.357 20.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15137",
    "data-name": "Group 15137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63024",
    "data-name": "Path 63024",
    d: "M398.207,620.334c4.069,3.737,9.035,8.126,14.012,12.08,7.606,6.046,19.206,13.309,19.315,13.377,3.148,2.1,9.257,5.674,12.886,4.555,4.109-1.263,20.091-15.532,25.892-20.789-.983-1.331-2.068-2.977-3.354-4.977-2.326,3.132-10.143,11.7-25.629,10.892C426.922,634.723,406.922,624.945,398.207,620.334Z",
    transform: "translate(-398.207 -620.334)",
    fill: "#cc5768"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15199",
    "data-name": "Group 15199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15141",
    "data-name": "Group 15141",
    transform: "translate(51.651 5.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15140",
    "data-name": "Group 15140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63025",
    "data-name": "Path 63025",
    d: "M339.081,550.359c-1.092-.9-5.173,1.657-5,2.484a5.287,5.287,0,0,0-4.333,2.955c-1.2-.365-3.814,2.3-3.448,4.232.657,3.474,4.232,7.994,10.253,10.86,2.714,1.292,13.821,3.209,16.178,5.046l5.615-8.193C356,558.215,348.93,556.233,339.081,550.359Z",
    transform: "translate(-326.269 -550.17)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15178",
    "data-name": "Group 15178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15175",
    "data-name": "Group 15175",
    transform: "translate(0 36.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15152",
    "data-name": "Group 15152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15143",
    "data-name": "Group 15143",
    transform: "translate(2.888 16.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15142",
    "data-name": "Group 15142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63026",
    "data-name": "Path 63026",
    d: "M207.633,685.8a1.428,1.428,0,0,0,1.142-.568l12.3-16.3a1.429,1.429,0,0,0-2.281-1.721l-12.3,16.3a1.428,1.428,0,0,0,1.139,2.289Z",
    transform: "translate(-206.205 -666.641)",
    fill: "#56ba85"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15145",
    "data-name": "Group 15145",
    transform: "translate(0 27.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15144",
    "data-name": "Group 15144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63027",
    "data-name": "Path 63027",
    d: "M204.764,699.929a.857.857,0,0,0,.506-1.549l-4.813-3.515a.857.857,0,0,0-1.011,1.385l4.813,3.516A.852.852,0,0,0,204.764,699.929Z",
    transform: "translate(-199.095 -694.699)",
    fill: "#56ba85"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15147",
    "data-name": "Group 15147",
    transform: "translate(3.276 27.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15146",
    "data-name": "Group 15146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63028",
    "data-name": "Path 63028",
    d: "M210.783,697.975a.858.858,0,0,0,.506-1.549l-2.766-2.021a.857.857,0,0,0-1.011,1.385l2.766,2.021A.852.852,0,0,0,210.783,697.975Z",
    transform: "translate(-207.16 -694.24)",
    fill: "#56ba85"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15149",
    "data-name": "Group 15149",
    transform: "translate(2.457 24.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15148",
    "data-name": "Group 15148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63029",
    "data-name": "Path 63029",
    d: "M210.815,691.647a.857.857,0,0,0,.506-1.549l-4.813-3.516a.857.857,0,0,0-1.011,1.385l4.813,3.516A.853.853,0,0,0,210.815,691.647Z",
    transform: "translate(-205.145 -686.417)",
    fill: "#56ba85"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15151",
    "data-name": "Group 15151",
    transform: "translate(10.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15150",
    "data-name": "Group 15150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63030",
    "data-name": "Path 63030",
    d: "M234.811,646.808a10.11,10.11,0,0,1-8.616-11.389h0a10.1,10.1,0,1,1,8.616,11.389Zm-5.786-11h0a7.236,7.236,0,1,0,7.167-6.247A7.249,7.249,0,0,0,229.026,635.812Z",
    transform: "translate(-226.099 -626.707)",
    fill: "#56ba85"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15163",
    "data-name": "Group 15163",
    transform: "translate(31.502 13.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15154",
    "data-name": "Group 15154",
    transform: "translate(4.785 17.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15153",
    "data-name": "Group 15153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63031",
    "data-name": "Path 63031",
    d: "M289.87,726.47a1.428,1.428,0,0,0,1.388-1.095l4.775-19.853a1.429,1.429,0,1,0-2.778-.668l-4.775,19.853a1.429,1.429,0,0,0,1.39,1.763Z",
    transform: "translate(-288.441 -703.759)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15156",
    "data-name": "Group 15156",
    transform: "translate(0 34.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15155",
    "data-name": "Group 15155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63032",
    "data-name": "Path 63032",
    d: "M283.333,748.1a.857.857,0,0,0,.187-1.694l-5.816-1.3a.857.857,0,0,0-.375,1.673l5.816,1.3A.889.889,0,0,0,283.333,748.1Z",
    transform: "translate(-276.658 -745.085)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15158",
    "data-name": "Group 15158",
    transform: "translate(2.93 32.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15157",
    "data-name": "Group 15157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63033",
    "data-name": "Path 63033",
    d: "M288.072,743.91a.857.857,0,0,0,.187-1.694l-3.343-.749a.857.857,0,0,0-.375,1.673l3.342.749A.886.886,0,0,0,288.072,743.91Z",
    transform: "translate(-283.871 -741.446)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15160",
    "data-name": "Group 15160",
    transform: "translate(0.911 30.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15159",
    "data-name": "Group 15159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63034",
    "data-name": "Path 63034",
    d: "M285.576,738.1a.857.857,0,0,0,.187-1.694l-5.816-1.3a.857.857,0,1,0-.375,1.673l5.816,1.3A.885.885,0,0,0,285.576,738.1Z",
    transform: "translate(-278.901 -735.078)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15162",
    "data-name": "Group 15162",
    transform: "translate(1.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15161",
    "data-name": "Group 15161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63035",
    "data-name": "Path 63035",
    d: "M281.852,673.815a10.093,10.093,0,1,1,9.728,7.38A10.03,10.03,0,0,1,281.852,673.815Zm7.774-9.693a7.241,7.241,0,0,0-5.023,8.923h0a7.243,7.243,0,1,0,5.023-8.923Z",
    transform: "translate(-281.474 -660.996)",
    fill: "#502a59"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15174",
    "data-name": "Group 15174",
    transform: "translate(60.644 10.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15165",
    "data-name": "Group 15165",
    transform: "translate(13.319 16.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15164",
    "data-name": "Group 15164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63036",
    "data-name": "Path 63036",
    d: "M391.446,713.969a1.429,1.429,0,0,0,1.287-2.045l-8.81-18.421a1.428,1.428,0,0,0-2.577,1.233l8.81,18.421A1.428,1.428,0,0,0,391.446,713.969Z",
    transform: "translate(-381.206 -692.69)",
    fill: "#9c78e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15167",
    "data-name": "Group 15167",
    transform: "translate(16.247 32.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15166",
    "data-name": "Group 15166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63037",
    "data-name": "Path 63037",
    d: "M389.274,738.643a.856.856,0,0,0,.381-.09l5.337-2.655a.857.857,0,0,0-.763-1.535l-5.337,2.655a.857.857,0,0,0,.383,1.625Z",
    transform: "translate(-388.416 -734.273)",
    fill: "#9c78e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15169",
    "data-name": "Group 15169",
    transform: "translate(17.59 31.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15168",
    "data-name": "Group 15168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63038",
    "data-name": "Path 63038",
    d: "M392.579,732.922a.846.846,0,0,0,.381-.09l3.067-1.525a.857.857,0,1,0-.763-1.535L392.2,731.3a.857.857,0,0,0,.382,1.625Z",
    transform: "translate(-391.721 -729.682)",
    fill: "#9c78e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15171",
    "data-name": "Group 15171",
    transform: "translate(14.392 29.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15170",
    "data-name": "Group 15170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63039",
    "data-name": "Path 63039",
    d: "M384.706,729.46a.854.854,0,0,0,.381-.09l5.337-2.655a.857.857,0,0,0-.764-1.534l-5.336,2.655a.857.857,0,0,0,.382,1.625Z",
    transform: "translate(-383.848 -725.09)",
    fill: "#9c78e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15173",
    "data-name": "Group 15173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15172",
    "data-name": "Group 15172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63040",
    "data-name": "Path 63040",
    d: "M352.672,671.409a10.107,10.107,0,1,1,5.82,1.852A10.11,10.11,0,0,1,352.672,671.409Zm-.076-12.426a7.247,7.247,0,1,0,5.92-3.055A7.249,7.249,0,0,0,352.6,658.983Z",
    transform: "translate(-348.411 -653.073)",
    fill: "#9c78e8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15177",
    "data-name": "Group 15177",
    transform: "translate(30.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15176",
    "data-name": "Group 15176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63041",
    "data-name": "Path 63041",
    d: "M273.479,560.7a23.333,23.333,0,1,1,23.333,23.333A23.36,23.36,0,0,1,273.479,560.7Zm1.143,0a22.19,22.19,0,1,0,22.19-22.19A22.216,22.216,0,0,0,274.622,560.7Z",
    transform: "translate(-273.479 -537.37)",
    fill: "#502a59"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15198",
    "data-name": "Group 15198",
    transform: "translate(54.482 0.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15192",
    "data-name": "Group 15192",
    transform: "translate(0 2.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15180",
    "data-name": "Group 15180",
    transform: "translate(1.874 4.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15179",
    "data-name": "Group 15179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63042",
    "data-name": "Path 63042",
    d: "M337.855,568.118s3.44,3.674,4.918,2.65a1.525,1.525,0,0,0,.321-2.35,1.774,1.774,0,0,0,2.65.069c1.346-1.368-.026-3.467-.026-3.467s2.921,4.426,5.008,3.823.553-3.924.287-4.335-1.1-2-1.1-2,1.676,2.917,2.758,3.113a1.5,1.5,0,0,0,1.962-1.283c.1-.948-1.053-8.036-1.053-8.036Z",
    transform: "translate(-337.855 -556.297)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15182",
    "data-name": "Group 15182",
    transform: "translate(9.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15181",
    "data-name": "Group 15181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63043",
    "data-name": "Path 63043",
    d: "M364.909,550.516c-.281-1.589-.662-4.034-3.747-4.351-2.382-.245-4.051,1.169-4.286,2.56s9.275,13.287,9.275,13.287S365.19,552.1,364.909,550.516Z",
    transform: "translate(-356.872 -546.137)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15191",
    "data-name": "Group 15191",
    transform: "translate(0 5.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15184",
    "data-name": "Group 15184",
    transform: "translate(11.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15183",
    "data-name": "Group 15183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63044",
    "data-name": "Path 63044",
    d: "M367.485,569.015a1.325,1.325,0,0,0,.472-.086c.886-.338,1.106-1.546,1.114-1.6a.286.286,0,0,0-.563-.1c-.047.261-.273.979-.757,1.162-.462.176-1.053-.179-1.467-.507-1.255-.994-4.362-6.815-4.393-6.874a.286.286,0,1,0-.5.269c.13.244,3.2,5.985,4.543,7.053A2.612,2.612,0,0,0,367.485,569.015Z",
    transform: "translate(-361.354 -560.864)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15186",
    "data-name": "Group 15186",
    transform: "translate(6.092 1.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15185",
    "data-name": "Group 15185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63045",
    "data-name": "Path 63045",
    d: "M356.34,573.432a1.887,1.887,0,0,0,1.2-.412c1.434-1.14-.189-4.574-.379-4.961a.286.286,0,1,0-.513.251c.459.939,1.451,3.536.537,4.263a1.391,1.391,0,0,1-1.07.275,4.7,4.7,0,0,1-2.7-1.747c-1.8-2.313-4.624-7.091-4.652-7.139a.286.286,0,1,0-.492.291c.028.048,2.873,4.857,4.693,7.2a5.25,5.25,0,0,0,3.079,1.964A2.425,2.425,0,0,0,356.34,573.432Z",
    transform: "translate(-348.24 -563.821)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15188",
    "data-name": "Group 15188",
    transform: "translate(2.401 3.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15187",
    "data-name": "Group 15187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63046",
    "data-name": "Path 63046",
    d: "M345.7,578.15a2.446,2.446,0,0,0,1.283-.358c.978-.868.812-2.635.1-3.855a.286.286,0,0,0-.494.287c.583,1,.738,2.5.041,3.118a1.967,1.967,0,0,1-2.137-.168c-.932-.644-3.661-4.344-4.808-6.366a.286.286,0,0,0-.5.282c1.092,1.926,3.909,5.814,4.98,6.553A2.651,2.651,0,0,0,345.7,578.15Z",
    transform: "translate(-339.153 -570.663)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15190",
    "data-name": "Group 15190",
    transform: "translate(0 7.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15189",
    "data-name": "Group 15189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63047",
    "data-name": "Path 63047",
    d: "M339.624,585.643a1.534,1.534,0,0,0,.817-.219,1.832,1.832,0,0,0,.638-2.414.286.286,0,0,0-.515.249,1.3,1.3,0,0,1-.422,1.678c-.675.413-1.989-.152-3.518-1.511a40.782,40.782,0,0,1-2.881-3.021.286.286,0,1,0-.433.373,40.326,40.326,0,0,0,2.934,3.075C337.069,584.586,338.46,585.643,339.624,585.643Z",
    transform: "translate(-333.241 -580.306)",
    fill: "#502a59"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15197",
    "data-name": "Group 15197",
    transform: "translate(9.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15194",
    "data-name": "Group 15194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15193",
    "data-name": "Group 15193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63048",
    "data-name": "Path 63048",
    d: "M378.474,553.033s-5.125-6.74-7.308-8.09c-2.355-1.457-11.824-6.4-13.948-4.838s7.14,9.91,7.14,9.91,2.21,8.361,7.328,10.439S378.474,553.033,378.474,553.033Z",
    transform: "translate(-356.902 -539.802)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15196",
    "data-name": "Group 15196",
    transform: "translate(0.293 2.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15195",
    "data-name": "Group 15195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63049",
    "data-name": "Path 63049",
    d: "M369.556,561.969a.286.286,0,0,0,.18-.508c-.03-.024-2.941-2.438-4.742-8.431a.29.29,0,0,0-.059-.106l-6.811-7.767a.286.286,0,1,0-.43.376l6.77,7.721c1.858,6.134,4.788,8.551,4.912,8.651A.285.285,0,0,0,369.556,561.969Z",
    transform: "translate(-357.623 -545.06)",
    fill: "#502a59"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15376",
    "data-name": "Group 15376",
    transform: "translate(98.193)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15259",
    "data-name": "Group 15259",
    transform: "translate(0 259.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15226",
    "data-name": "Group 15226",
    transform: "translate(115.798 4.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15208",
    "data-name": "Group 15208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15203",
    "data-name": "Group 15203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15202",
    "data-name": "Group 15202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15201",
    "data-name": "Group 15201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63050",
    "data-name": "Path 63050",
    d: "M731.237,1095.33c.052,3.149.1,5.874.149,8.12.1,4.788.171,7.428.171,7.428l9.989,2.612,15.794-4.114s.349-1.966.932-5.32c3.063-17.532,12.663-72.973,13.509-83.476,1.006-12.509.966-65.481.966-65.481l-46.766,8.708c.394,18.618,6.006,48.544,6.452,54.835C732.986,1026.472,730.889,1074.964,731.237,1095.33Z",
    transform: "translate(-725.98 -955.099)",
    fill: "#e8747a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15205",
    "data-name": "Group 15205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15204",
    "data-name": "Group 15204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63051",
    "data-name": "Path 63051",
    d: "M731.923,1051.758c13.023-9.709,5.372-60.959,10.822-71.655,5.927-11.634,20.634-11.195,29.973-9.712.035-8.886.029-15.292.029-15.292l-46.766,8.708c.394,18.618,6.006,48.544,6.452,54.835C732.706,1022.511,732.334,1036.323,731.923,1051.758Z",
    transform: "translate(-725.98 -955.099)",
    fill: "#cc5768"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15207",
    "data-name": "Group 15207",
    transform: "translate(34.213 53.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15206",
    "data-name": "Group 15206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63052",
    "data-name": "Path 63052",
    d: "M814.088,1105.365a.286.286,0,0,0,.178-.509,10.877,10.877,0,0,1-3.367-9.633c1-7.477,8.323-7.563,8.4-7.563a.286.286,0,0,0,0-.572c-.079,0-7.9.092-8.963,8.06a11.454,11.454,0,0,0,3.577,10.156A.284.284,0,0,0,814.088,1105.365Z",
    transform: "translate(-810.219 -1087.088)",
    fill: "#502a59"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15225",
    "data-name": "Group 15225",
    transform: "translate(2.495 148.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15210",
    "data-name": "Group 15210",
    transform: "translate(2.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15209",
    "data-name": "Group 15209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63053",
    "data-name": "Path 63053",
    d: "M739.29,1320.368c.1,4.788.171,7.428.171,7.428l9.989,2.612,15.794-4.114s.349-1.966.932-5.32A129.486,129.486,0,0,1,739.29,1320.368Z",
    transform: "translate(-739.29 -1320.368)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15224",
    "data-name": "Group 15224",
    transform: "translate(0 2.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15215",
    "data-name": "Group 15215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15212",
    "data-name": "Group 15212",
    transform: "translate(0.084 13.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15211",
    "data-name": "Group 15211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63054",
    "data-name": "Path 63054",
    d: "M789.661,1376.784c-.878,2.151-1.8,5.1-3.715,5.574-2.31.568-9.8-.138-28.6-5.683-18.593-5.483-24.245-7.882-24.595-8.415s-.418-7.709-.418-7.709l30.518,8.641Z",
    transform: "translate(-732.329 -1360.55)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15214",
    "data-name": "Group 15214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15213",
    "data-name": "Group 15213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63055",
    "data-name": "Path 63055",
    d: "M763.384,1329.7s8.873,7.861,13.609,12.527c2.581,2.542,9.458,5.619,11.914,9.272,2.121,3.155.13,7.058-1.049,7.62-2.547,1.214-23.672-4.861-32.477-7.649s-21.707-6.779-22.791-8.989-.3-14.09,2.5-14.292c3.505-.255,10.073,7.292,10.812,3.9.24-1.1,1.181-5.557,9.781-5.7S763.384,1329.7,763.384,1329.7Z",
    transform: "translate(-732.123 -1326.381)",
    fill: "#56ba85"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15223",
    "data-name": "Group 15223",
    transform: "translate(23.853 9.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15220",
    "data-name": "Group 15220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15217",
    "data-name": "Group 15217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15216",
    "data-name": "Group 15216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63056",
    "data-name": "Path 63056",
    d: "M791.14,1354.724a.287.287,0,0,0,.093-.015l14.028-4.834a.286.286,0,0,0-.186-.54l-14.028,4.833a.286.286,0,0,0,.093.555Z",
    transform: "translate(-790.854 -1349.32)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15219",
    "data-name": "Group 15219",
    transform: "translate(3.896 2.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15218",
    "data-name": "Group 15218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63057",
    "data-name": "Path 63057",
    d: "M800.732,1361.715a.285.285,0,0,0,.095-.016l13.482-4.752a.286.286,0,1,0-.19-.539l-13.482,4.752a.286.286,0,0,0,.095.555Z",
    transform: "translate(-800.446 -1356.392)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15222",
    "data-name": "Group 15222",
    transform: "translate(12.371 10.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15221",
    "data-name": "Group 15221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63058",
    "data-name": "Path 63058",
    d: "M821.6,1385.245a.285.285,0,0,0,.267-.184c3.809-10.013,15.043-8.051,15.157-8.031a.286.286,0,1,0,.1-.562c-.118-.023-11.815-2.073-15.8,8.39a.286.286,0,0,0,.267.388Z",
    transform: "translate(-821.313 -1376.291)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15258",
    "data-name": "Group 15258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15237",
    "data-name": "Group 15237",
    transform: "translate(27.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15229",
    "data-name": "Group 15229",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15228",
    "data-name": "Group 15228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15227",
    "data-name": "Group 15227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63059",
    "data-name": "Path 63059",
    d: "M508.7,1103.168l16.679,3.936,9.941-2.809c6.188-29.32,22.039-59.7,32.522-85.912,8.207-20.949,19.339-63.816,19.339-63.816l-46.3-10.281Z",
    transform: "translate(-508.701 -944.285)",
    fill: "#e8747a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15236",
    "data-name": "Group 15236",
    transform: "translate(10.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15231",
    "data-name": "Group 15231",
    transform: "translate(0 53.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15230",
    "data-name": "Group 15230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63060",
    "data-name": "Path 63060",
    d: "M534.32,1129.373c9.061,5.088,24.369-12.958,27.752-28.65s-1.8-23.654-10.677-25.568a10.43,10.43,0,0,0-6.229.663Z",
    transform: "translate(-534.32 -1074.942)",
    fill: "#cc5768"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15233",
    "data-name": "Group 15233",
    transform: "translate(16.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15232",
    "data-name": "Group 15232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63061",
    "data-name": "Path 63061",
    d: "M574.334,971.536c20.663,4.183,40.184,1.143,47.31-.28,1.72-6.194,3.086-11.275,3.84-14.143l-18.4-6.783-27.229-6.052Z",
    transform: "translate(-574.334 -944.279)",
    fill: "#cc5768"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15235",
    "data-name": "Group 15235",
    transform: "translate(12.145 60.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15234",
    "data-name": "Group 15234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63062",
    "data-name": "Path 63062",
    d: "M564.509,1102.6h.013c8.472-.394,10.735-9.454,10.757-9.545a.286.286,0,0,0-.556-.133c-.021.087-2.189,8.734-10.227,9.108a.286.286,0,0,0,.013.571Z",
    transform: "translate(-564.223 -1092.703)",
    fill: "#502a59"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15257",
    "data-name": "Group 15257",
    transform: "translate(0 151.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15239",
    "data-name": "Group 15239",
    transform: "translate(27.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15238",
    "data-name": "Group 15238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63063",
    "data-name": "Path 63063",
    d: "M508.7,1324.416l16.68,3.937,9.937-2.806q.763-3.625,1.72-7.268c-4.737.565-15.474,1.537-26.806-1.429Z",
    transform: "translate(-508.698 -1316.85)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15256",
    "data-name": "Group 15256",
    transform: "translate(0 4.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15244",
    "data-name": "Group 15244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15241",
    "data-name": "Group 15241",
    transform: "translate(0.341 13.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15240",
    "data-name": "Group 15240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63064",
    "data-name": "Path 63064",
    d: "M441.7,1377.361c.92,2.134,1.9,5.066,3.824,5.5,2.321.522,9.793-.33,28.487-6.245,18.482-5.847,24.086-8.358,24.424-8.9s.266-7.716.266-7.716l-30.341,9.24Z",
    transform: "translate(-441.704 -1360.002)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15243",
    "data-name": "Group 15243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15242",
    "data-name": "Group 15242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63065",
    "data-name": "Path 63065",
    d: "M466.828,1330.451s-8.716,8.034-13.36,12.792c-2.531,2.593-9.346,5.8-11.73,9.5-2.058,3.2.009,7.059,1.2,7.6,2.57,1.164,23.572-5.326,32.32-8.287s21.569-7.2,22.609-9.436.017-14.093-2.777-14.24c-3.509-.186-9.927,7.49-10.733,4.116-.262-1.1-1.29-5.532-9.892-5.511S466.828,1330.451,466.828,1330.451Z",
    transform: "translate(-440.864 -1326.988)",
    fill: "#56ba85"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15255",
    "data-name": "Group 15255",
    transform: "translate(0.681 9.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15249",
    "data-name": "Group 15249",
    transform: "translate(14.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15246",
    "data-name": "Group 15246",
    transform: "translate(3.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15245",
    "data-name": "Group 15245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63066",
    "data-name": "Path 63066",
    d: "M501.8,1355.747a.285.285,0,0,0,.088-.557l-14.12-4.556a.285.285,0,1,0-.175.543l14.12,4.556A.286.286,0,0,0,501.8,1355.747Z",
    transform: "translate(-487.392 -1350.619)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15248",
    "data-name": "Group 15248",
    transform: "translate(0 2.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15247",
    "data-name": "Group 15247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63067",
    "data-name": "Path 63067",
    d: "M493.143,1362.91a.286.286,0,0,0,.089-.557l-13.573-4.485a.286.286,0,1,0-.179.542l13.573,4.485A.277.277,0,0,0,493.143,1362.91Z",
    transform: "translate(-479.284 -1357.853)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15254",
    "data-name": "Group 15254",
    transform: "translate(0 10.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15251",
    "data-name": "Group 15251",
    transform: "translate(0 4.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15250",
    "data-name": "Group 15250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63068",
    "data-name": "Path 63068",
    d: "M445.781,1396.94c2.664,0,6.478-1,10.435-2.043.73-.191,1.464-.385,2.2-.573,6.706-1.723,17.826-5.716,17.938-5.756a.286.286,0,1,0-.193-.538c-.112.04-11.207,4.024-17.887,5.74-.732.188-1.468.382-2.2.574-5.683,1.493-11.56,3.038-13.02,1.173a.285.285,0,0,0-.45.351C443.2,1396.637,444.317,1396.94,445.781,1396.94Z",
    transform: "translate(-442.54 -1388.015)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15253",
    "data-name": "Group 15253",
    transform: "translate(5.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15252",
    "data-name": "Group 15252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63069",
    "data-name": "Path 63069",
    d: "M471.711,1386.068a.282.282,0,0,0,.173-.059.285.285,0,0,0,.054-.4c-.069-.091-7.019-9.041-16.373-8.409a.286.286,0,1,0,.039.57c9.057-.622,15.813,8.1,15.88,8.185A.286.286,0,0,0,471.711,1386.068Z",
    transform: "translate(-455.298 -1377.168)",
    fill: "#fff"
  })))))))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15261",
    "data-name": "Group 15261",
    transform: "translate(66.64 181.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15260",
    "data-name": "Group 15260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63070",
    "data-name": "Path 63070",
    d: "M605.207,757.343c-.982,3.2.835,8.708,4.611,10.485s6.664-17.216,6.664-17.216S606.927,751.746,605.207,757.343Z",
    transform: "translate(-604.944 -750.612)",
    fill: "#502a59"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15276",
    "data-name": "Group 15276",
    transform: "translate(54.231 183.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15263",
    "data-name": "Group 15263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15262",
    "data-name": "Group 15262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63071",
    "data-name": "Path 63071",
    d: "M684.458,762.053s3.8,26.622,4.25,48.1-2.237,35.794-2.237,35.794a85.582,85.582,0,0,0-29.977,1.118c-15.436,3.579-33.333,7.383-53.691,2.908s-28.411-12.081-28.411-12.081a738.969,738.969,0,0,1,23.042-81.878Z",
    transform: "translate(-574.392 -756.013)",
    fill: "#1b3d9e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15270",
    "data-name": "Group 15270",
    transform: "translate(16.827 3.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15265",
    "data-name": "Group 15265",
    transform: "translate(45.674 3.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15264",
    "data-name": "Group 15264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63072",
    "data-name": "Path 63072",
    d: "M733.312,810.344a3.786,3.786,0,0,0,1.969-.417c1.714-1.091,1.928-31.1,1.953-37.11a.285.285,0,0,0-.284-.287h0a.286.286,0,0,0-.286.284c-.058,13.616-.569,35.6-1.7,36.635-1.27.807-4.99-.083-6.316-.495a.286.286,0,0,0-.17.546A19.5,19.5,0,0,0,733.312,810.344Z",
    transform: "translate(-728.281 -772.531)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15267",
    "data-name": "Group 15267",
    transform: "translate(71.201 3.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15266",
    "data-name": "Group 15266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63073",
    "data-name": "Path 63073",
    d: "M815.24,793.434a.286.286,0,0,0,.077-.56c-10.679-3.018-18.633-9.808-23.641-20.18a.286.286,0,1,0-.515.248c5.082,10.526,13.157,17.418,24,20.482A.269.269,0,0,0,815.24,793.434Z",
    transform: "translate(-791.133 -772.531)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15269",
    "data-name": "Group 15269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15268",
    "data-name": "Group 15268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63074",
    "data-name": "Path 63074",
    d: "M622.377,780.606c11.183,0,19.037-5.771,22.418-16.672a.286.286,0,1,0-.546-.169c-3.947,12.724-13.663,18.161-28.094,15.719a.286.286,0,1,0-.1.564A37.977,37.977,0,0,0,622.377,780.606Z",
    transform: "translate(-615.822 -763.565)",
    fill: "#502a59"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15275",
    "data-name": "Group 15275",
    transform: "translate(9.234 0.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15272",
    "data-name": "Group 15272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15271",
    "data-name": "Group 15271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63075",
    "data-name": "Path 63075",
    d: "M597.128,801.326c21.675-21.115,59.521-32.189,77.39-36.458-7.04.063-15.194-.109-24.132-.72-19.16-1.314-31.5-6.154-39.624-6.886Q603.228,779.5,597.128,801.326Z",
    transform: "translate(-597.128 -757.262)",
    fill: "#1b3d9e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15274",
    "data-name": "Group 15274",
    transform: "translate(30.12 52.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15273",
    "data-name": "Group 15273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63076",
    "data-name": "Path 63076",
    d: "M671.29,929.712c12.749,1.125,24.435-.623,35.069-2.875-2.286-10.771-8.909-39-15.526-39.378S674.69,917.912,671.29,929.712Z",
    transform: "translate(-671.29 -887.457)",
    fill: "#294eb6"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15375",
    "data-name": "Group 15375",
    transform: "translate(35.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15323",
    "data-name": "Group 15323",
    transform: "translate(0 74.301)"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15283",
    "data-name": "Group 15283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15278",
    "data-name": "Group 15278",
    transform: "translate(31.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15277",
    "data-name": "Group 15277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63077",
    "data-name": "Path 63077",
    d: "M703.894,520.783s-1.4,47.108,2.626,82.2c0,0-21.149,2.937-51.11.881S612.174,591.131,605.592,601c0,0,7.716-33.2,10.2-52.864,2.954-23.337,5.181-56.362,5.181-56.362,5.921-1.442,12.78-2.594,20.093-3.607a220.817,220.817,0,0,1,50.1,1.393Z",
    transform: "translate(-605.592 -487.352)",
    fill: "#50ab32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15280",
    "data-name": "Group 15280",
    transform: "translate(116.721 2.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15279",
    "data-name": "Group 15279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63078",
    "data-name": "Path 63078",
    d: "M815.905,492.794c4.77.35,11.214,2.493,15.83,4.893a92.283,92.283,0,0,0,29.827,10.726s-6.69.515-7.719,15.094-1.8,21.4-6.108,25.916L828.629,542.2s-11.149-18.354-11.492-26.415S815.905,492.794,815.905,492.794Z",
    transform: "translate(-815.905 -492.794)",
    fill: "#50ab32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15282",
    "data-name": "Group 15282",
    transform: "translate(0 3.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15281",
    "data-name": "Group 15281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63079",
    "data-name": "Path 63079",
    d: "M581.365,495.272s-15.052,1.882-24.358,9.509c-10.427,8.547-28.491,30.925-28.491,30.925a30.59,30.59,0,0,1,13.727,11.318c5.209,8.186,7.456,11.8,10.8,12.92l28.821-23.71Z",
    transform: "translate(-528.516 -495.272)",
    fill: "#50ab32"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15298",
    "data-name": "Group 15298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15297",
    "data-name": "Group 15297",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15296",
    "data-name": "Group 15296",
    transform: "translate(-22.707 9.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15285",
    "data-name": "Group 15285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15284",
    "data-name": "Group 15284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63080",
    "data-name": "Path 63080",
    d: "M472.894,510.334h222.63a.286.286,0,0,0,0-.571H472.894a.286.286,0,1,0,0,.571Z",
    transform: "translate(-472.608 -509.763)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15287",
    "data-name": "Group 15287",
    transform: "translate(0 19.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15286",
    "data-name": "Group 15286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63081",
    "data-name": "Path 63081",
    d: "M472.894,558.878h222.63a.286.286,0,0,0,0-.571H472.894a.286.286,0,1,0,0,.571Z",
    transform: "translate(-472.608 -558.307)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15289",
    "data-name": "Group 15289",
    transform: "translate(0 39.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15288",
    "data-name": "Group 15288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63082",
    "data-name": "Path 63082",
    d: "M472.894,607.423h222.63a.286.286,0,0,0,0-.571H472.894a.286.286,0,1,0,0,.571Z",
    transform: "translate(-472.608 -606.852)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15291",
    "data-name": "Group 15291",
    transform: "translate(0 59.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15290",
    "data-name": "Group 15290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63083",
    "data-name": "Path 63083",
    d: "M472.894,655.968h222.63a.286.286,0,0,0,0-.571H472.894a.286.286,0,1,0,0,.571Z",
    transform: "translate(-472.608 -655.397)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15293",
    "data-name": "Group 15293",
    transform: "translate(0 78.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15292",
    "data-name": "Group 15292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63084",
    "data-name": "Path 63084",
    d: "M472.894,704.512h222.63a.286.286,0,0,0,0-.572H472.894a.286.286,0,1,0,0,.572Z",
    transform: "translate(-472.608 -703.941)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15295",
    "data-name": "Group 15295",
    transform: "translate(0 98.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15294",
    "data-name": "Group 15294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63085",
    "data-name": "Path 63085",
    d: "M472.894,753.056h222.63a.286.286,0,0,0,0-.571H472.894a.286.286,0,1,0,0,.571Z",
    transform: "translate(-472.608 -752.485)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15322",
    "data-name": "Group 15322",
    transform: "translate(8.009 0.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15303",
    "data-name": "Group 15303",
    transform: "translate(0 40.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15300",
    "data-name": "Group 15300",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15299",
    "data-name": "Group 15299",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63087",
    "data-name": "Path 63087",
    d: "M548.235,596.344a27.862,27.862,0,0,1,5.72,6.434c5.206,8.183,7.457,11.8,10.806,12.92l17.794-14.64,1.051-11.9S569.515,599.664,548.235,596.344Z",
    transform: "translate(-548.235 -589.155)",
    fill: "#7b90c0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15302",
    "data-name": "Group 15302",
    transform: "translate(26.229 4.109)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15301",
    "data-name": "Group 15301",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63088",
    "data-name": "Path 63088",
    d: "M612.816,654.266a67.568,67.568,0,0,1,23.079-12.176c12.889-3.609,28.563-6.83,29.014-8.779s-14.475,1.84-27.378-8.137c-11.737-9.069-15.069-22.652-15.72-25.9-.537,5.274-1.114,10.508-1.726,15.331C618.6,626.311,615.267,642.826,612.816,654.266Z",
    transform: "translate(-612.816 -599.271)",
    fill: "#7b90c0"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15321",
    "data-name": "Group 15321",
    transform: "translate(29.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15308",
    "data-name": "Group 15308",
    transform: "translate(31.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15305",
    "data-name": "Group 15305",
    transform: "translate(0 2.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15304",
    "data-name": "Group 15304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63089",
    "data-name": "Path 63089",
    d: "M702.234,517.259a.286.286,0,0,0,.25-.147,17.441,17.441,0,0,1,11.944-8.486.286.286,0,0,0-.073-.567,18.075,18.075,0,0,0-12.007,8.153c-.56-2.421-2.43-10.845-3.579-20.14a.286.286,0,1,0-.567.071,208.311,208.311,0,0,0,3.754,20.9.285.285,0,0,0,.239.216Z",
    transform: "translate(-698.2 -495.821)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15307",
    "data-name": "Group 15307",
    transform: "translate(23.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15306",
    "data-name": "Group 15306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63090",
    "data-name": "Path 63090",
    d: "M775.779,512.928a.286.286,0,0,0,.283-.328l-3.5-23.241a.286.286,0,0,0-.262-.242l-5.056-.378a.286.286,0,1,0-.042.57l4.829.361,3.342,22.2c-2.1-1.893-9.39-7.808-18.071-7.5a.285.285,0,0,0-.275.3.291.291,0,0,0,.3.275c10.025-.358,18.17,7.818,18.251,7.9A.285.285,0,0,0,775.779,512.928Z",
    transform: "translate(-757.028 -488.738)",
    fill: "#502a59"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15315",
    "data-name": "Group 15315",
    transform: "translate(44.811 24.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15310",
    "data-name": "Group 15310",
    transform: "translate(0.357 14.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15309",
    "data-name": "Group 15309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63091",
    "data-name": "Path 63091",
    d: "M732.513,584.766a1.495,1.495,0,1,0,1.495-1.5A1.495,1.495,0,0,0,732.513,584.766Z",
    transform: "translate(-732.513 -583.271)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15312",
    "data-name": "Group 15312",
    transform: "translate(0 27.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15311",
    "data-name": "Group 15311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63092",
    "data-name": "Path 63092",
    d: "M731.633,618.167a1.5,1.5,0,1,0,1.5-1.495A1.5,1.5,0,0,0,731.633,618.167Z",
    transform: "translate(-731.633 -616.672)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15314",
    "data-name": "Group 15314",
    transform: "translate(3.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15313",
    "data-name": "Group 15313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63093",
    "data-name": "Path 63093",
    d: "M743.006,581.79a.286.286,0,0,0,.286-.281c0-.166.238-16.637.085-21.249a77.685,77.685,0,0,0-1.807-11.751.286.286,0,0,0-.556.13,77.159,77.159,0,0,1,1.792,11.64c.152,4.6-.083,21.056-.086,21.222a.286.286,0,0,0,.281.29Z",
    transform: "translate(-741.006 -548.288)",
    fill: "#502a59"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15320",
    "data-name": "Group 15320",
    transform: "translate(0 34.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15317",
    "data-name": "Group 15317",
    transform: "translate(91.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15316",
    "data-name": "Group 15316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63094",
    "data-name": "Path 63094",
    d: "M847.208,628.951h.016a.286.286,0,0,0,.27-.3c-1.047-19.589-1.349-38.367-.9-55.813a.286.286,0,0,0-.278-.293.292.292,0,0,0-.293.278c-.453,17.461-.151,36.255.9,55.859A.285.285,0,0,0,847.208,628.951Z",
    transform: "translate(-845.821 -572.544)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15319",
    "data-name": "Group 15319",
    transform: "translate(0 5.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15318",
    "data-name": "Group 15318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63095",
    "data-name": "Path 63095",
    d: "M621.585,629.081a.286.286,0,0,0,.281-.235,379.31,379.31,0,0,0,5.41-42,.286.286,0,1,0-.57-.038,378.772,378.772,0,0,1-5.4,41.932.286.286,0,0,0,.23.332A.324.324,0,0,0,621.585,629.081Z",
    transform: "translate(-621.299 -586.546)",
    fill: "#502a59"
  })))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15374",
    "data-name": "Group 15374",
    transform: "translate(63.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15328",
    "data-name": "Group 15328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15325",
    "data-name": "Group 15325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15324",
    "data-name": "Group 15324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63096",
    "data-name": "Path 63096",
    d: "M733.109,370.464S750.3,356.759,749.58,337.4a35.422,35.422,0,0,0-21.159-31.258c-6.805-2.7-13.308-2.25-15.148,1.322,0,0-2.909-4.527-10.7-2.164-9.486,2.878-16.877,17.57-16.591,33.181a50.464,50.464,0,0,0,8.536,26.569C706.742,357.464,722.147,358.925,733.109,370.464Z",
    transform: "translate(-685.974 -304.409)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15327",
    "data-name": "Group 15327",
    transform: "translate(8.006 24.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15326",
    "data-name": "Group 15326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63097",
    "data-name": "Path 63097",
    d: "M706.225,400.913c12.223-7.589,27.629-6.126,38.589,5.411,0,0,5.926-32.155-1.537-40.795l-31.5-.737S703.539,371.61,706.225,400.913Z",
    transform: "translate(-705.686 -364.793)",
    fill: "#3a2045"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15337",
    "data-name": "Group 15337",
    transform: "translate(13.956 43.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15334",
    "data-name": "Group 15334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15333",
    "data-name": "Group 15333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15330",
    "data-name": "Group 15330",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15329",
    "data-name": "Group 15329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63098",
    "data-name": "Path 63098",
    d: "M745.434,443.3l-25.1-.627,2.493-30.931h22.605Z",
    transform: "translate(-720.336 -411.738)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15332",
    "data-name": "Group 15332",
    transform: "translate(0.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15331",
    "data-name": "Group 15331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63099",
    "data-name": "Path 63099",
    d: "M746.845,414.622v15.363c-9.309,5.608-19.875,2.41-24.137.694l1.531-18.943S745.857,413.6,746.845,414.622Z",
    transform: "translate(-722.708 -411.736)",
    fill: "#cc5768"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15336",
    "data-name": "Group 15336",
    transform: "translate(0 26.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15335",
    "data-name": "Group 15335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63100",
    "data-name": "Path 63100",
    d: "M745.434,482.086l-9.911,15.632-4.707,20.248L727.537,497.2l-7.2-15.74,15.321-4.4Z",
    transform: "translate(-720.336 -477.056)",
    fill: "#e8747a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15373",
    "data-name": "Group 15373",
    transform: "translate(6.351 8.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15364",
    "data-name": "Group 15364",
    transform: "translate(4.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15342",
    "data-name": "Group 15342",
    transform: "translate(0 1.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15339",
    "data-name": "Group 15339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15338",
    "data-name": "Group 15338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63101",
    "data-name": "Path 63101",
    d: "M749.228,350.88c.972,13.416-6.447,26.65-16.217,27.359s-18.193-11.378-19.165-24.794,5.873-23.082,15.644-23.79S748.256,337.464,749.228,350.88Z",
    transform: "translate(-713.754 -329.613)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15341",
    "data-name": "Group 15341",
    transform: "translate(8.467 41.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15340",
    "data-name": "Group 15340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63102",
    "data-name": "Path 63102",
    d: "M744.564,439.481c.281,0,.564-.01.846-.031a15.681,15.681,0,0,0,11.323-6.785.286.286,0,0,0-.463-.336,15.112,15.112,0,0,1-10.9,6.551c-3.57.262-7.125-1.225-10.283-4.3a.286.286,0,1,0-.4.41C737.718,437.942,741.115,439.481,744.564,439.481Z",
    transform: "translate(-734.601 -432.212)",
    fill: "#3a2045"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15344",
    "data-name": "Group 15344",
    transform: "translate(14.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15343",
    "data-name": "Group 15343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63103",
    "data-name": "Path 63103",
    d: "M750.636,325.269s2.19,11.511,23.849,18.311c0,0-.56-11.779-10.054-15.853S750.636,325.269,750.636,325.269Z",
    transform: "translate(-750.636 -324.952)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15363",
    "data-name": "Group 15363",
    transform: "translate(7.173 10.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15357",
    "data-name": "Group 15357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15354",
    "data-name": "Group 15354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15353",
    "data-name": "Group 15353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15346",
    "data-name": "Group 15346",
    transform: "translate(10.186 12.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15345",
    "data-name": "Group 15345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63104",
    "data-name": "Path 63104",
    d: "M757.742,391.121c1.1,0,2.807-.122,3.564-.816a1.162,1.162,0,0,0,.4-.868c.015-1.235-2.322-2.6-2.936-2.933l-.828-3.765a.286.286,0,0,0-.558.123l.856,3.893a.284.284,0,0,0,.146.191c1.067.563,2.758,1.735,2.749,2.484a.6.6,0,0,1-.218.453c-.777.712-3.235.7-4.116.634a.286.286,0,1,0-.043.57C756.87,391.1,757.245,391.121,757.742,391.121Z",
    transform: "translate(-756.497 -382.515)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15352",
    "data-name": "Group 15352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15351",
    "data-name": "Group 15351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15348",
    "data-name": "Group 15348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15347",
    "data-name": "Group 15347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63105",
    "data-name": "Path 63105",
    d: "M731.416,355.86s1.8-3.528,4.985-3.827c3.16-.3,5.361,1.215,5.178,2.222s-3.492-.161-5.172-.06A17.369,17.369,0,0,0,731.416,355.86Z",
    transform: "translate(-731.416 -351.995)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15350",
    "data-name": "Group 15350",
    transform: "translate(16.587 4.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15349",
    "data-name": "Group 15349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63106",
    "data-name": "Path 63106",
    d: "M782.435,367.838s-1.814-3.522-5-3.81c-3.161-.286-5.357,1.233-5.17,2.239s3.492-.173,5.172-.078A17.372,17.372,0,0,1,782.435,367.838Z",
    transform: "translate(-772.256 -363.993)",
    fill: "#502a59"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15356",
    "data-name": "Group 15356",
    transform: "translate(8.019 23.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15355",
    "data-name": "Group 15355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63107",
    "data-name": "Path 63107",
    d: "M751.947,412.075c.844,1.056,2.014,1.523,2.615,1.044s.4-1.725-.439-2.782-2.014-1.523-2.616-1.044S751.1,411.019,751.947,412.075Z",
    transform: "translate(-751.16 -409.105)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15362",
    "data-name": "Group 15362",
    transform: "translate(4.177 9.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15359",
    "data-name": "Group 15359",
    transform: "translate(15.365 0.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15358",
    "data-name": "Group 15358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63108",
    "data-name": "Path 63108",
    d: "M782.209,377.734c.1,1.081-.423,2.01-1.159,2.075s-1.41-.758-1.506-1.839.424-2.01,1.159-2.075S782.113,376.654,782.209,377.734Z",
    transform: "translate(-779.533 -375.892)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15361",
    "data-name": "Group 15361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15360",
    "data-name": "Group 15360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63109",
    "data-name": "Path 63109",
    d: "M744.377,377.447c.1,1.081-.423,2.01-1.159,2.075s-1.41-.758-1.505-1.839.423-2.01,1.159-2.075S744.281,376.366,744.377,377.447Z",
    transform: "translate(-741.701 -375.604)",
    fill: "#502a59"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15372",
    "data-name": "Group 15372",
    transform: "translate(0 18.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15366",
    "data-name": "Group 15366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15365",
    "data-name": "Group 15365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63110",
    "data-name": "Path 63110",
    d: "M711.682,378.568c.792,4,.513,7.835-2.16,8.364s-6.9-2.67-7.691-6.673.609-8.287,3.282-8.816S710.89,374.564,711.682,378.568Z",
    transform: "translate(-701.611 -371.392)",
    fill: "#e8747a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15371",
    "data-name": "Group 15371",
    transform: "translate(2.121 3.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15368",
    "data-name": "Group 15368",
    transform: "translate(0.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15367",
    "data-name": "Group 15367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63111",
    "data-name": "Path 63111",
    d: "M711.089,386.728l.033,0a.285.285,0,0,0,.252-.316,9.885,9.885,0,0,0-3.5-6.7.286.286,0,0,0-.367.438,9.329,9.329,0,0,1,3.3,6.322A.286.286,0,0,0,711.089,386.728Z",
    transform: "translate(-707.409 -379.648)",
    fill: "#502a59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15370",
    "data-name": "Group 15370",
    transform: "translate(0 3.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15369",
    "data-name": "Group 15369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63112",
    "data-name": "Path 63112",
    d: "M707.118,388.911a.284.284,0,0,0,.069-.009,5.542,5.542,0,0,1,2.651-.052.285.285,0,1,0,.117-.559,6.15,6.15,0,0,0-2.9.056.286.286,0,0,0,.068.563Z",
    transform: "translate(-706.832 -388.144)",
    fill: "#502a59"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.a6e8a7e1e076cf3531ec23330a721a87.svg";
export { ForwardRef as ReactComponent };